<template>
  <notify-popover @ring-bell="ringBell">
    <template #reference>
      <div
        class="notify-container"
        :class="{ ring: ring }"
      >
        <ms-tooltip
          placement="bottom"
          effect="light"
          :hide-after="0"
        >
          <template #content>
            <span>{{ $t('Common.NotifyTooltip') }}</span>
          </template>
          <img
            class="icon outline-none"
            :src="notice.src"
            :width="notice.width"
            :height="notice.height"
          >
        </ms-tooltip>

        <div
          v-if="numberNotifyUnPreview > 0"
          class="number-notify-unpreview"
        >
          {{ 100 > numberNotifyUnPreview ? numberNotifyUnPreview : 99 }}
        </div>
      </div>
    </template>
  </notify-popover>
</template>

<script>
import MsTooltip from '@/components/tooltip'
import NotifyPopover from '@/views/pages/common/notify/notify-popover'
import { mapState } from 'vuex'

export default {
  components: {
    NotifyPopover,
    MsTooltip
  },

  data () {
    return {
      notice: {
        src: require('@/assets/icons/svg/common/ic_Noti_24.svg'),
        width: 24,
        height: 24
      },
      ring: false
    }
  },

  computed: {
    ...mapState('notify', {
      numberNotifyUnPreview: 'numberNotifyUnPreview'
    })
  },

  methods: {
    ringBell () {
      const me = this

      me.ring = true
      setTimeout(() => {
        me.ring = false
      }, 375)
    }
  }
}
</script>

<style lang="scss" scoped>
.notify-container {
  position: sticky;
  right: 79px;
  width: auto;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  padding: 0 8px;
  cursor: pointer;

  &.ring {
    animation: animate-ring 0.125s 4;
  }

  //  animation
  @keyframes animate-ring {
    0% {
      transform: rotate(-15deg);
    }
    25% {
      transform: rotate(0);
    }
    75% {
      transform: rotate(15deg);
    }
    100% {
      transform: rotate(0);
    }
  }

  .number-notify-unpreview {
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: $color-semantic-pink;
    color: $color-primary;
    top: 0;
    right: 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    @include caption();
    @include font-bold();
  }
}
</style>
>
